import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import BadgeSelector from "./BadgeSelector";
import { OpenTo as OpenToEnum } from "@/generated-api";
import { useTranslation } from "@/hooks/useTranslation";
import { OPEN_TO_EMOJI_MAP } from "./openToEmojiMap";

export default function OpenToField({
  form,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}) {
  const t = useTranslation();

  return (
    <>
      <FormField
        control={form.control}
        name="openTo"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel htmlFor="openTo" className="flex sm:flex-col">
              <div>{t.USER_FORM.LABELS.OPEN_TO}</div>
              <span className="text-gray-400 text-xs ml-1 sm:ml-0">
                {t.USER_FORM.LABELS.OPEN_TO_MIN}
              </span>
            </FormLabel>
            <div>
              <FormControl>
                <BadgeSelector
                  selectedValues={field.value || []}
                  onChange={field.onChange}
                  enumObject={OpenToEnum}
                  maxSelections={3}
                  valueToImageMap={OPEN_TO_EMOJI_MAP}
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
    </>
  );
}
